import script from "./SearchClient.vue?vue&type=script&setup=true&lang=js"
export * from "./SearchClient.vue?vue&type=script&setup=true&lang=js"

import "./SearchClient.vue?vue&type=style&index=0&id=49242d15&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-49242d15"]])

export default __exports__